<template>
  <v-card
    v-if="$store.state.isMobile"
    tile
    v-touch="{
      right: () => swipe(),
    }"
  >
    <div class="object__photo">
      <button
        class="btn-reset close__card"
        @click="this.$emit('update:modal', false)"
      >
        <svg
          width="26"
          height="24"
          viewBox="0 0 26 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1_1545)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.3125 12.0184C21.3125 12.2546 21.2187 12.4812 21.0516 12.6482C20.8846 12.8152 20.6581 12.909 20.4218 12.909L7.78879 12.909L12.7266 17.6115C12.8886 17.7771 12.9797 17.9992 12.9806 18.2309C12.9815 18.4625 12.8921 18.6853 12.7315 18.8521C12.5708 19.019 12.3515 19.1167 12.12 19.1245C11.8885 19.1323 11.6631 19.0497 11.4915 18.894L4.96006 12.6597C4.87386 12.5766 4.8053 12.477 4.75847 12.3668C4.71164 12.2566 4.6875 12.1381 4.6875 12.0184C4.6875 11.8987 4.71164 11.7802 4.75847 11.67C4.8053 11.5599 4.87386 11.4602 4.96006 11.3772L11.4915 5.14279C11.5749 5.05759 11.6745 4.98999 11.7845 4.94399C11.8944 4.89799 12.0125 4.87454 12.1317 4.87501C12.2509 4.87548 12.3688 4.89987 12.4784 4.94674C12.588 4.9936 12.6871 5.06199 12.7697 5.14785C12.8524 5.23371 12.917 5.33529 12.9597 5.44657C13.0024 5.55785 13.0224 5.67657 13.0183 5.7957C13.0143 5.91483 12.9864 6.03193 12.9363 6.14008C12.8862 6.24823 12.8149 6.34521 12.7266 6.42529L7.78879 11.1278L20.4218 11.1278C20.6581 11.1278 20.8846 11.2216 21.0516 11.3887C21.2187 11.5557 21.3125 11.7822 21.3125 12.0184Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_1_1545"
              x="0.6875"
              y="0.875"
              width="24.625"
              height="22.25"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_1_1545"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_1_1545"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </button>
      <v-carousel :show-arrows="false" hide-delimiters height="450px">
        <v-carousel-item
          v-for="(photo, index) in item.photos"
          :key="index"
          :src="photo"
          cover
        ></v-carousel-item>
      </v-carousel>
    </div>
    <div class="object__card flex">
      <div class="object__status__block mb-5 flex">
        <div class="object__status">{{ item.status }}</div>
        <div class="object__type">
          {{ item.type }}
        </div>
      </div>
      <div class="object__price__block mb-5 flex">
        <div class="object__price">
          {{ item.currency }} {{ item.fullPrice }}
        </div>
        <div class="object__price__square gray-text">
          {{ item.squarePrice }} за м²
        </div>
      </div>
      <div class="object__title__block mb-5">
        <h2>{{ item.lot_name }}</h2>
        <p class="gray-text">{{ item.lot_adress }}</p>
      </div>
      <div class="characters__block mb-5">
        <div class="divider"></div>
        <div class="characters flex">
          <div class="flex column">
            <div class="bold-text text-center">{{ item.lot_square }} м²</div>
            <div class="gray-text text-center">площадь</div>
          </div>
          <div class="flex column">
            <div class="bold-text text-center">
              {{ item.lot_floor.split(":")[0] }}/{{
                item.lot_floor.split(":")[1].trim()
              }}
            </div>
            <div class="gray-text text-center">этаж</div>
          </div>
          <div class="flex column">
            <div class="bold-text text-center">
              {{ item.lot_otc != "Без отделки" ? "Есть" : "Нет" }}
            </div>
            <div class="gray-text text-center">отделка</div>
          </div>
          <div class="flex column">
            <div class="bold-text text-center">
              {{ item.status == "Вторичка" ? "Да" : "Нет" }}
            </div>
            <div class="gray-text text-center">вторичка</div>
          </div>
        </div>
        <div class="divider"></div>
      </div>
      <div class="actions__block flex column">
        <v-btn
          class="rounded-xl"
          color="#ff8351"
          elevation="0"
          min-height="50px"
          width="100%"
          :loading="loading"
          @click="createPresentation('enable')"
          >Создать PDF</v-btn
        >
        <!-- <v-btn
          :disabled="item.selected"
          class="rounded-xl mb-2"
          :color="item.selected ? '#ff8351' : '#F4F6F9'"
          elevation="0"
          height="100%"
          width="100%"
          @click="selected"
          >Добавить в подборку</v-btn
        >-->
      </div>
      <div class="object__discription__block mb-5">
        <div class="extra__block flex column mb-5">
          <v-row class="comission">
            <v-col class="comission__title gray-text" cols="6">Комиссия</v-col>
            <v-col class="comission__value bold-text" cols="6">{{
              item.comission
            }}</v-col>
          </v-row>
          <v-row class="comission">
            <v-col class="comission__title gray-text" cols="6"
              >Актуализировано</v-col
            >
            <v-col class="comission__value bold-text" cols="6">{{
              item.lot_date_update
            }}</v-col>
          </v-row>
          <v-row class="comission">
            <v-col class="comission__title gray-text" cols="6"
              >Тип сделки</v-col
            >
            <v-col class="comission__value bold-text" cols="6">{{
              item.type
            }}</v-col>
          </v-row>
          <!-- <v-row class="comission">
            <v-col class="comission__title gray-text" cols="6">ID</v-col>
            <v-col class="comission__value bold-text" cols="6">{{
              item.id
            }}</v-col>
          </v-row>-->
        </div>
        <h2 class="mb-4">Описание</h2>
        <div class="discriptions">{{ item.lot_description }}</div>
      </div>
      <!-- <div class="assigned_block mb-5">
        <h2 class="mb-5">Ответственный</h2>
        <div class="assigned flex">
          <div class="assigned__avatar mr-5">
            <v-avatar :image="item.assigned.avatar" size="60"></v-avatar>
          </div>
          <div class="assigned__name__block flex column">
            <div class="gray-text">{{ item.assigned.position }}</div>
            <div class="assigned__name bold-text">{{ item.assigned.name }}</div>
          </div>
        </div>
      </div>-->
    </div>
  </v-card>
  <v-card
    v-else
    class="flex"
    style="flex-direction: row; justify-content: space-between"
  >
    <v-container fluid class="pa-4">
      <div class="logo mb-12">
        <svg
          width="71"
          height="61"
          viewBox="0 0 91 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.6635 10.082C18.4274 10.8168 17.0504 11.8015 15.5672 13.0717C14.772 11.3842 14.1088 9.31956 13.6248 7.13302C16.2403 3.74996 18.532 2.39136 18.532 2.39136C18.5618 4.07278 18.8369 7.06889 19.6635 10.082Z"
            fill="#EC4900"
          />
          <path
            d="M19.6635 10.082C18.4274 10.8168 17.0504 11.8015 15.5672 13.0717C14.772 11.3842 14.1088 9.31956 13.6248 7.13302C16.2403 3.74996 18.532 2.39136 18.532 2.39136C18.5618 4.07278 18.8369 7.06889 19.6635 10.082Z"
            fill="url(#paint0_linear_374_747)"
          />
          <path
            d="M18.4074 10.4462C17.7359 8.4486 17.4362 6.44144 17.3521 5.30984C17.3521 5.30984 15.8605 6.31236 14.228 8.69025L15.2606 12.5076L18.4872 11.2337"
            fill="url(#paint1_linear_374_747)"
          />
          <path
            d="M29.2121 60.1947C28.8911 60.1947 28.5704 60.191 28.2575 60.1833C-0.956879 59.5222 -4.86076 29.9872 5.3398 17.0654C8.01469 13.6794 6.29467 5.83281 14.5509 0C14.4117 1.56938 14.3963 3.22764 14.4969 4.83162C14.6129 6.7797 14.899 8.65061 15.3511 10.216C16.8045 9.32685 18.1303 8.66604 19.2939 8.2059C21.2614 7.41363 22.7842 7.17012 23.7545 7.23186C24.9258 7.31303 26.1587 8.42626 28.0991 8.89784C32.1848 8.2059 35.451 7.02321 39.5712 4.94739C43.4637 15.6001 33.236 21.6418 24.6588 32.0973C17.3147 41.0652 16.5453 54.331 29.2121 60.1947Z"
            fill="url(#paint2_linear_374_747)"
          />
          <path
            d="M28.2572 60.1833L25.7362 60.0858C24.8984 60.0145 24.0627 59.9083 23.2249 59.821C22.393 59.6938 21.5664 59.5275 20.7358 59.3822C19.9191 59.1759 19.0986 58.975 18.2871 58.7448C15.063 57.7455 12.0056 56.1671 9.36242 54.0409C8.07381 52.9445 6.82937 51.7748 5.79891 50.4237C5.24296 49.7804 4.79533 49.0571 4.30645 48.3638C4.07624 48.008 3.87318 47.6346 3.65549 47.2708L3.334 46.7215C3.23101 46.5363 3.14372 46.3425 3.04765 46.1536L2.48451 45.0124L2.00068 43.8359C1.92191 43.6389 1.83568 43.4449 1.76329 43.2458L1.5613 42.6428C1.43063 42.2396 1.28319 41.8412 1.16636 41.4337C0.953987 40.613 0.711009 39.7989 0.568362 38.9622L0.44461 38.3384L0.383135 38.0265L0.340287 37.7114L0.169165 36.451C-0.177605 33.0796 -0.000894719 29.6468 0.788718 26.3475C1.18259 24.7005 1.69649 23.0749 2.41159 21.5348C3.1187 19.9958 3.94717 18.498 5.01143 17.1697C6.0733 15.9008 6.45386 14.2319 6.86557 12.6146C7.26424 10.9848 7.66423 9.33588 8.29124 7.76197C8.91505 6.1894 9.76241 4.70306 10.824 3.3889C11.3576 2.73422 11.9447 2.12584 12.5658 1.55711C13.1891 0.989189 13.8643 0.484604 14.5509 0.000244141C13.1987 0.998504 11.9628 2.15405 10.9347 3.47645C9.91384 4.80392 9.11358 6.28973 8.53475 7.85592C7.94234 9.41971 7.56736 11.054 7.19264 12.6929C7.00289 13.5123 6.80622 14.3354 6.53397 15.1445C6.39292 15.5471 6.24096 15.9495 6.03737 16.3327C5.94449 16.5278 5.82473 16.7117 5.70896 16.8959L5.33611 17.4188L4.6101 18.4333L3.96287 19.5002L3.8008 19.7666L3.65629 20.0431L3.36966 20.5975L3.08277 21.1519C2.99335 21.3397 2.91564 21.533 2.83128 21.7232C2.13668 23.2373 1.63954 24.8372 1.2603 26.458C0.498901 29.7045 0.343481 33.0825 0.697436 36.3929L0.859777 37.6318L0.900229 37.9416L0.95931 38.2481L1.078 38.8616C1.21373 39.6847 1.44899 40.4847 1.65338 41.2922C1.76595 41.693 1.9094 42.0844 2.03555 42.4812L2.23089 43.0745C2.30088 43.2703 2.38498 43.4611 2.46136 43.6546L2.93081 44.8123L3.47825 45.9348C3.57139 46.1209 3.65602 46.3117 3.75635 46.494L4.06932 47.0342C4.28143 47.3922 4.47863 47.7597 4.70298 48.1102C5.17989 48.792 5.61528 49.505 6.15819 50.1381C7.16736 51.4653 8.37188 52.6278 9.62163 53.7272C12.1898 55.8554 15.1848 57.4559 18.3649 58.4976C21.5459 59.5581 24.9018 60.0345 28.2572 60.1833Z"
            fill="url(#paint3_linear_374_747)"
          />
          <path
            d="M29.2123 60.1948C-0.252997 56.9829 2.51078 24.8464 14.9764 18.9247C13.2998 18.6299 10.2073 18.6626 10.2073 18.6626C14.418 13.794 34.2874 13.7283 39.5712 4.94751C43.4636 15.6002 33.2359 21.6419 24.6588 32.0975C17.3149 41.0653 16.5455 54.3312 29.2123 60.1948Z"
            fill="url(#paint4_linear_374_747)"
          />
          <path
            d="M29.467 23.7988C27.3757 25.9866 25.219 28.2477 23.1046 30.826C18.3773 36.593 16.3944 43.6897 17.7937 49.8046C18.4159 52.5064 19.6491 54.9183 21.4503 56.9824C15.2271 54.8875 10.3995 44.5671 11.9417 35.932C10.8902 37.5554 10.0168 39.322 9.41772 41.1617C7.17955 18.7274 34.1789 17.4441 38.2685 7.80399C39.1963 13.2621 35.5473 17.4326 29.467 23.7988Z"
            fill="url(#paint5_linear_374_747)"
          />
          <path
            d="M29.4671 23.7988C27.3759 25.9866 25.2191 28.2477 23.1047 30.826C18.3774 36.593 16.3945 43.6897 17.7938 49.8046C18.416 52.5064 19.6493 54.9183 21.4504 56.9824C12.0036 49.6769 14.2279 35.1107 19.6636 28.2024C18.0865 28.5966 15.4774 30.385 15.4774 30.385C19.6636 21.2285 38.4118 17.0654 38.2686 7.80399C39.1964 13.2621 35.5474 17.4326 29.4671 23.7988Z"
            fill="url(#paint6_linear_374_747)"
          />
          <path
            d="M11.9417 35.9324C10.932 37.5893 10.0907 39.3501 9.52734 41.1978L9.36474 41.7311L9.30273 41.1736C9.19361 40.1942 9.13267 39.2085 9.1356 38.2206C9.14518 37.233 9.21091 36.2446 9.34717 35.2636C9.62395 33.3028 10.2073 31.376 11.1079 29.6027C11.9997 27.825 13.1888 26.2053 14.557 24.7711C15.2404 24.0525 15.9675 23.3771 16.7243 22.7397C17.4849 22.1063 18.277 21.5131 19.0868 20.9489C22.3357 18.6964 25.8521 16.9085 29.3145 15.0783C31.0414 14.154 32.7511 13.1949 34.3489 12.0713C35.1422 11.5042 35.9092 10.8937 36.5871 10.1911C36.9296 9.84298 37.2372 9.46321 37.5284 9.07093C37.811 8.67227 38.059 8.24912 38.2677 7.80441C38.0811 8.25843 37.8528 8.69569 37.5875 9.11112C37.3133 9.52016 37.0126 9.91298 36.6805 10.2781C36.021 11.0132 35.2684 11.6585 34.4876 12.2603C32.9129 13.4512 31.2035 14.4396 29.4957 15.4089L24.3503 18.2642C22.6474 19.2294 20.9726 20.2418 19.3801 21.3675C18.5838 21.9301 17.8096 22.522 17.0647 23.1472C16.3164 23.7681 15.5989 24.4251 14.9248 25.1235C13.5755 26.5177 12.4053 28.0884 11.5236 29.8143C10.6443 31.5396 10.0343 33.402 9.7163 35.32C9.56141 36.2797 9.47545 37.2511 9.44431 38.2251C9.4185 39.2 9.4648 40.1753 9.53187 41.1504L9.30725 41.1262C9.9489 39.2817 10.8434 37.5332 11.9417 35.9324Z"
            fill="url(#paint7_linear_374_747)"
          />
          <path
            d="M29.2121 60.1948C26.8326 59.9763 24.4619 59.5518 22.1703 58.8343C19.8768 58.1275 17.6758 57.1002 15.6612 55.777C14.6537 55.1154 13.7028 54.3654 12.8184 53.5436C11.9383 52.717 11.1263 51.8167 10.3963 50.8538C8.93422 48.9289 7.80689 46.7538 7.04362 44.4613C6.27211 42.1694 5.88595 39.7566 5.82793 37.3452C5.77072 34.9325 6.04616 32.5125 6.66039 30.1791C7.27303 27.8478 8.23882 25.5979 9.59662 23.6011C10.9393 21.607 12.7402 19.8607 14.9395 18.8483L14.961 19.0074C14.1839 18.8661 13.3882 18.8028 12.5946 18.7535C11.7999 18.7064 11.0037 18.6737 10.2069 18.6623C11.0037 18.6426 11.8013 18.6364 12.5989 18.6588C13.3965 18.6838 14.1943 18.7219 14.9906 18.8414L15.2501 18.8802L15.0121 19.0005C13.954 19.536 12.9826 20.2335 12.1334 21.0574C11.2746 21.8715 10.5254 22.7979 9.88112 23.7906C8.57814 25.772 7.69751 28.0051 7.10403 30.2935C5.92773 34.8827 6.0749 39.8035 7.53437 44.2987C8.26676 46.5451 9.35551 48.6774 10.7737 50.5688C11.4819 51.5149 12.2707 52.4006 13.1277 53.2155C13.9814 54.0333 14.8982 54.7891 15.8773 55.4574C17.8321 56.7995 19.9909 57.8432 22.2453 58.6049C24.4949 59.3926 26.8457 59.8669 29.2121 60.1948Z"
            fill="url(#paint8_linear_374_747)"
          />
          <path
            d="M46.2088 49.2377H44.8374C44.2755 49.2377 43.8183 49.0663 43.466 48.7234C43.1136 48.371 42.9374 47.871 42.9374 47.2234V29.7234L43.1231 29.5377H44.3517C45.0183 29.5377 45.4945 29.7091 45.7802 30.052C46.066 30.3853 46.2088 30.9139 46.2088 31.6377V49.2377ZM54.3374 46.3948C54.3374 47.4805 54.166 48.2282 53.8231 48.6377C53.4898 49.0377 52.9279 49.2377 52.1374 49.2377H44.8374L43.1374 46.8377C44.0707 46.6853 45.0374 46.5758 46.0374 46.5091C47.0374 46.4329 47.9469 46.3948 48.766 46.3948H54.3374ZM60.5776 49.1948C60.1204 49.2805 59.5918 49.3234 58.9918 49.3234C58.3918 49.3234 57.8633 49.2805 57.4061 49.1948V38.8663C57.4061 38.371 57.3157 37.9996 57.1347 37.752C56.9538 37.4948 56.6252 37.3663 56.149 37.3663H55.8061C55.7204 37.0043 55.6776 36.6329 55.6776 36.252C55.6776 36.071 55.6871 35.8853 55.7061 35.6948C55.7252 35.4948 55.7585 35.2948 55.8061 35.0948C56.1776 35.0472 56.5347 35.0139 56.8776 34.9948C57.2204 34.9758 57.5014 34.9663 57.7204 34.9663H58.149C58.9014 34.9663 59.4918 35.2043 59.9204 35.6805C60.3585 36.1567 60.5776 36.8091 60.5776 37.6377V49.1948ZM56.5204 31.2234C56.5204 30.7282 56.6109 30.2853 56.7918 29.8948C56.9823 29.7901 57.2299 29.7043 57.5347 29.6377C57.849 29.5615 58.1538 29.5234 58.449 29.5234C58.7252 29.5234 59.0299 29.5615 59.3633 29.6377C59.6966 29.7043 59.9442 29.7901 60.1061 29.8948C60.1823 30.0758 60.2442 30.2901 60.2918 30.5377C60.349 30.7853 60.3776 31.0139 60.3776 31.2234C60.3776 31.7186 60.2871 32.1663 60.1061 32.5663C59.9538 32.671 59.7061 32.7567 59.3633 32.8234C59.0299 32.8901 58.7252 32.9234 58.449 32.9234C58.1538 32.9234 57.8442 32.8901 57.5204 32.8234C57.2061 32.7567 56.9633 32.671 56.7918 32.5663C56.6109 32.1663 56.5204 31.7186 56.5204 31.2234ZM63.5173 48.1663C63.5363 47.8043 63.6459 47.4091 63.8459 46.9805C64.0459 46.5424 64.2744 46.1996 64.5316 45.952C65.1411 46.2758 65.7887 46.5663 66.4744 46.8234C67.1601 47.0805 67.8506 47.2091 68.5459 47.2091C69.2887 47.2091 69.8744 47.052 70.303 46.7377C70.7411 46.4234 70.9601 46.0234 70.9601 45.5377C70.9601 45.1567 70.8173 44.8091 70.5316 44.4948C70.2459 44.171 69.8173 43.9043 69.2459 43.6948L67.5887 43.0805C66.9316 42.8424 66.3268 42.5424 65.7744 42.1805C65.2316 41.8186 64.7935 41.3758 64.4601 40.852C64.1363 40.3282 63.9744 39.7043 63.9744 38.9805C63.9744 38.0948 64.1935 37.3329 64.6316 36.6948C65.0792 36.0472 65.6887 35.552 66.4601 35.2091C67.2411 34.8567 68.1221 34.6805 69.103 34.6805C69.8935 34.6805 70.7316 34.7901 71.6173 35.0091C72.5125 35.2186 73.2554 35.4615 73.8459 35.7377C73.8649 36.1282 73.784 36.552 73.603 37.0091C73.4316 37.4663 73.2078 37.8091 72.9316 38.0377C72.4173 37.8091 71.8221 37.5948 71.1459 37.3948C70.4792 37.1853 69.7935 37.0805 69.0887 37.0805C68.5078 37.0805 68.0411 37.2234 67.6887 37.5091C67.3363 37.7948 67.1601 38.171 67.1601 38.6377C67.1601 39.0091 67.2982 39.3234 67.5744 39.5805C67.8506 39.8282 68.2697 40.0567 68.8316 40.2663L70.5887 40.9234C71.6649 41.3043 72.5411 41.8424 73.2173 42.5377C73.903 43.2329 74.2459 44.1424 74.2459 45.2663C74.2459 46.5996 73.7268 47.652 72.6887 48.4234C71.6506 49.1948 70.2744 49.5805 68.5601 49.5805C67.5506 49.5805 66.6125 49.4377 65.7459 49.152C64.8887 48.8663 64.1459 48.5377 63.5173 48.1663ZM76.0452 48.1663C76.0642 47.8043 76.1738 47.4091 76.3738 46.9805C76.5738 46.5424 76.8023 46.1996 77.0595 45.952C77.669 46.2758 78.3166 46.5663 79.0023 46.8234C79.6881 47.0805 80.3785 47.2091 81.0738 47.2091C81.8166 47.2091 82.4023 47.052 82.8309 46.7377C83.269 46.4234 83.4881 46.0234 83.4881 45.5377C83.4881 45.1567 83.3452 44.8091 83.0595 44.4948C82.7738 44.171 82.3452 43.9043 81.7738 43.6948L80.1166 43.0805C79.4595 42.8424 78.8547 42.5424 78.3023 42.1805C77.7595 41.8186 77.3214 41.3758 76.9881 40.852C76.6642 40.3282 76.5023 39.7043 76.5023 38.9805C76.5023 38.0948 76.7214 37.3329 77.1595 36.6948C77.6071 36.0472 78.2166 35.552 78.988 35.2091C79.769 34.8567 80.65 34.6805 81.6309 34.6805C82.4214 34.6805 83.2595 34.7901 84.1452 35.0091C85.0404 35.2186 85.7833 35.4615 86.3738 35.7377C86.3928 36.1282 86.3119 36.552 86.1309 37.0091C85.9595 37.4663 85.7357 37.8091 85.4595 38.0377C84.9452 37.8091 84.35 37.5948 83.6738 37.3948C83.0071 37.1853 82.3214 37.0805 81.6166 37.0805C81.0357 37.0805 80.569 37.2234 80.2166 37.5091C79.8642 37.7948 79.6881 38.171 79.6881 38.6377C79.6881 39.0091 79.8261 39.3234 80.1023 39.5805C80.3785 39.8282 80.7976 40.0567 81.3595 40.2663L83.1166 40.9234C84.1928 41.3043 85.069 41.8424 85.7452 42.5377C86.4309 43.2329 86.7738 44.1424 86.7738 45.2663C86.7738 46.5996 86.2547 47.652 85.2166 48.4234C84.1785 49.1948 82.8023 49.5805 81.0881 49.5805C80.0785 49.5805 79.1404 49.4377 78.2738 49.152C77.4166 48.8663 76.6738 48.5377 76.0452 48.1663Z"
            fill="black"
          />
          <defs>
            <linearGradient
              id="paint0_linear_374_747"
              x1="16.4896"
              y1="-1.58997"
              x2="16.6837"
              y2="11.2207"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF6624" />
              <stop offset="0.1843" stop-color="#EE5E1F" />
              <stop offset="0.5478" stop-color="#C34712" />
              <stop offset="1" stop-color="#852800" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_374_747"
              x1="16.5671"
              y1="4.8299"
              x2="16.3697"
              y2="9.66567"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.495" stop-color="#EEEEEE" />
              <stop offset="1" stop-color="#C3C3C3" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_374_747"
              x1="18.2812"
              y1="-0.346876"
              x2="23.9584"
              y2="60.6834"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF8351" />
              <stop offset="0.595" stop-color="#EE5C1D" />
              <stop offset="1" stop-color="#C3440B" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_374_747"
              x1="9.73803"
              y1="0.216183"
              x2="15.4518"
              y2="61.6399"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A83400" />
              <stop offset="0.2731" stop-color="#C3440B" />
              <stop offset="0.7546" stop-color="#EE5C1D" />
              <stop offset="1" stop-color="#FF6624" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_374_747"
              x1="22.6593"
              y1="-15.5777"
              x2="23.6647"
              y2="50.779"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF6624" />
              <stop offset="0.385" stop-color="#EE5E1F" />
              <stop offset="1" stop-color="#C34712" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_374_747"
              x1="27.8736"
              y1="3.67056"
              x2="16.0311"
              y2="61.6992"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.2101" stop-color="#EEEEEE" />
              <stop offset="0.6219" stop-color="#C3C3C3" />
              <stop offset="1" stop-color="#969696" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_374_747"
              x1="32.2811"
              y1="-0.758187"
              x2="19.3528"
              y2="50.7576"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" />
              <stop offset="0.625" stop-color="#EEEEEE" />
              <stop offset="1" stop-color="#C3C3C3" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_374_747"
              x1="22.357"
              y1="9.15772"
              x2="25.3151"
              y2="40.9569"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF6624" />
              <stop offset="0.2454" stop-color="#EE5C1D" />
              <stop offset="0.7269" stop-color="#C3440B" />
              <stop offset="1" stop-color="#A83400" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_374_747"
              x1="14.6254"
              y1="17.9854"
              x2="18.6674"
              y2="61.4376"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF6624" />
              <stop offset="0.2454" stop-color="#EE5C1D" />
              <stop offset="0.7269" stop-color="#C3440B" />
              <stop offset="1" stop-color="#A83400" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <v-row>
        <v-col cols="1">
          <button
            class="btn-reset close__filter align-self-center"
            @click="this.$emit('update:modal', false)"
          >
            <svg
              width="80"
              height="24"
              viewBox="0 0 80 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8101 6.70978C13.9028 6.80229 13.9763 6.91218 14.0265 7.03315C14.0767 7.15413 14.1025 7.28381 14.1025 7.41478C14.1025 7.54575 14.0767 7.67543 14.0265 7.7964C13.9763 7.91738 13.9028 8.02726 13.8101 8.11978L9.9301 11.9998L13.8101 15.8798C13.9971 16.0668 14.1021 16.3204 14.1021 16.5848C14.1021 16.8492 13.9971 17.1028 13.8101 17.2898C13.6231 17.4768 13.3695 17.5818 13.1051 17.5818C12.8407 17.5818 12.5871 17.4768 12.4001 17.2898L7.8101 12.6998C7.71739 12.6073 7.64384 12.4974 7.59366 12.3764C7.54348 12.2554 7.51765 12.1257 7.51765 11.9948C7.51765 11.8638 7.54348 11.7341 7.59366 11.6132C7.64384 11.4922 7.71739 11.3823 7.8101 11.2898L12.4001 6.69978C12.7801 6.31978 13.4201 6.31978 13.8101 6.70978Z"
                fill="#8B9AB0"
              />
              <path
                d="M44.1719 18H42.7656V12.8672H36.5781V18H35.1719V6.72656H36.5781V11.6016H42.7656V6.72656H44.1719V18ZM49.0938 16.8984C49.7812 16.8984 50.349 16.7005 50.7969 16.3047C51.25 15.9036 51.4766 15.401 51.4766 14.7969V14.1172L49.2734 14.2578C47.9922 14.3359 47.3516 14.7865 47.3516 15.6094C47.3516 16 47.5078 16.3125 47.8203 16.5469C48.138 16.7812 48.5625 16.8984 49.0938 16.8984ZM48.8047 18.0781C47.9505 18.0781 47.263 17.8516 46.7422 17.3984C46.2214 16.9453 45.9609 16.3464 45.9609 15.6016C45.9609 14.8776 46.2318 14.3099 46.7734 13.8984C47.3151 13.4818 48.0964 13.2422 49.1172 13.1797L51.4766 13.0391V12.3359C51.4766 11.8151 51.3099 11.4141 50.9766 11.1328C50.6432 10.8516 50.1667 10.7109 49.5469 10.7109C49.0573 10.7109 48.6432 10.8281 48.3047 11.0625C47.9714 11.2969 47.763 11.612 47.6797 12.0078H46.375C46.3958 11.2995 46.7109 10.7057 47.3203 10.2266C47.9297 9.74219 48.6771 9.5 49.5625 9.5C50.5573 9.5 51.3516 9.7474 51.9453 10.2422C52.5391 10.7318 52.8359 11.3906 52.8359 12.2188V18H51.5469V16.5391H51.5156C51.276 17.0078 50.9115 17.3828 50.4219 17.6641C49.9323 17.9401 49.3932 18.0781 48.8047 18.0781ZM57.5234 18.1406C56.6068 18.1406 55.8438 17.9323 55.2344 17.5156C54.6302 17.099 54.2917 16.5417 54.2188 15.8438H55.6016C55.6849 16.2135 55.8932 16.5 56.2266 16.7031C56.5651 16.9062 56.9974 17.0078 57.5234 17.0078C58.1328 17.0078 58.6068 16.8776 58.9453 16.6172C59.2839 16.3568 59.4531 16.013 59.4531 15.5859C59.4531 15.1068 59.2943 14.7552 58.9766 14.5312C58.6589 14.3021 58.1745 14.1875 57.5234 14.1875H56.25V13.0625H57.5234C58.6224 13.0625 59.1719 12.6432 59.1719 11.8047C59.1719 11.4297 59.0365 11.1302 58.7656 10.9062C58.4948 10.6823 58.0938 10.5703 57.5625 10.5703C57.0573 10.5703 56.6406 10.6719 56.3125 10.875C55.9844 11.0781 55.7917 11.349 55.7344 11.6875H54.4062C54.4948 10.9948 54.8229 10.4453 55.3906 10.0391C55.9583 9.63281 56.6823 9.42969 57.5625 9.42969C58.4948 9.42969 59.2161 9.63802 59.7266 10.0547C60.2422 10.4661 60.5 11.0156 60.5 11.7031C60.5 12.1406 60.3698 12.5286 60.1094 12.8672C59.8542 13.2057 59.5156 13.4245 59.0938 13.5234V13.5859C59.6458 13.7057 60.0651 13.9349 60.3516 14.2734C60.6432 14.6068 60.7891 15.0208 60.7891 15.5156C60.7891 16.2969 60.4896 16.9297 59.8906 17.4141C59.2917 17.8984 58.5026 18.1406 57.5234 18.1406ZM65.1719 16.8984C65.8594 16.8984 66.4271 16.7005 66.875 16.3047C67.3281 15.9036 67.5547 15.401 67.5547 14.7969V14.1172L65.3516 14.2578C64.0703 14.3359 63.4297 14.7865 63.4297 15.6094C63.4297 16 63.5859 16.3125 63.8984 16.5469C64.2161 16.7812 64.6406 16.8984 65.1719 16.8984ZM64.8828 18.0781C64.0286 18.0781 63.3411 17.8516 62.8203 17.3984C62.2995 16.9453 62.0391 16.3464 62.0391 15.6016C62.0391 14.8776 62.3099 14.3099 62.8516 13.8984C63.3932 13.4818 64.1745 13.2422 65.1953 13.1797L67.5547 13.0391V12.3359C67.5547 11.8151 67.388 11.4141 67.0547 11.1328C66.7214 10.8516 66.2448 10.7109 65.625 10.7109C65.1354 10.7109 64.7214 10.8281 64.3828 11.0625C64.0495 11.2969 63.8411 11.612 63.7578 12.0078H62.4531C62.474 11.2995 62.7891 10.7057 63.3984 10.2266C64.0078 9.74219 64.7552 9.5 65.6406 9.5C66.6354 9.5 67.4297 9.7474 68.0234 10.2422C68.6172 10.7318 68.9141 11.3906 68.9141 12.2188V18H67.625V16.5391H67.5938C67.3542 17.0078 66.9896 17.3828 66.5 17.6641C66.0104 17.9401 65.4714 18.0781 64.8828 18.0781ZM76.4141 16.875V10.7031H73.2188L72.9531 14.3047C72.8646 15.487 72.6328 16.3229 72.2578 16.8125V16.875H76.4141ZM71.25 20.2266H69.9844V16.875H70.6875C70.9792 16.6823 71.2083 16.3542 71.375 15.8906C71.5417 15.4219 71.6458 14.8828 71.6875 14.2734L72.0156 9.57812H77.7578V16.875H79.1016V20.2266H77.8359V18H71.25V20.2266Z"
                fill="#8B9AB0"
              />
            </svg>
          </button>
        </v-col>
      </v-row>
      <div class="pa-4">
        <h2>{{ item.jk_name }}</h2>
        <h3>{{ item.lot_name }}</h3>
        <p class="gray-text">{{ item.lot_adress }}</p>
      </div>
      <v-row class="position-relative">
        <v-col cols="8">
          <v-carousel
            style="border-radius: 15px"
            show-arrows="hover"
            class="desktop mb-6"
            hide-delimiter-background
          >
            <v-carousel-item
              v-for="(photo, index) in item.photos"
              :key="index"
              :src="photo"
              cover
            >
            </v-carousel-item>
          </v-carousel>
          <v-row class="description">
            <v-col>
              <v-sheet border rounded="xl" class="pa-4">
                <h3 class="mb-4">Характеристики</h3>
                <div class="characters-block flex mb-6">
                  <div class="mr-10">
                    <div class="characters__floor flex align-center mr-1 mb-4">
                      <svg
                        class="characters__icon"
                        width="50"
                        height="50"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.0383 2.22559H12.7501C12.2448 2.22559 11.8354 2.63472 11.8354 3.14009V5.51406H9.46149C8.95611 5.51406 8.54669 5.92304 8.54669 6.42845V8.80257H6.17272C5.66735 8.80257 5.25807 9.21214 5.25807 9.717V12.2055H2.77016C2.5274 12.2055 2.29476 12.3017 2.12331 12.473C1.95171 12.6444 1.85547 12.8781 1.85547 13.1199L1.85577 15.0332C1.85577 15.5391 2.26534 15.9482 2.77042 15.9482H16.0383C16.5437 15.9482 16.9529 15.5391 16.9529 15.0332V3.14005C16.953 2.63472 16.5437 2.22559 16.0383 2.22559Z"
                          fill="#8B9AB0"
                          fill-opacity="0.75"
                        />
                      </svg>
                      <div class="flex column">
                        <h4 class="characters__text">
                          {{ item.lot_floor.split(":")[0] }}/{{
                            item.lot_floor.split(":")[1].trim()
                          }}
                        </h4>
                        <span class="gray-text characters__text"> этаж</span>
                      </div>
                      <!--  <span class="gray-text characters__text">этаж</span>-->
                    </div>
                    <div class="characters__bedroom flex align-center mr-1">
                      <svg
                        class="characters__icon"
                        width="50"
                        height="50"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.43748 7.875V5.4375H7.125C6.40199 5.4375 5.91632 5.4387 5.55404 5.4874C5.20795 5.53393 5.05982 5.61435 4.96209 5.71209C4.86435 5.80983 4.78393 5.95795 4.7374 6.30404C4.68869 6.66632 4.6875 7.15199 4.6875 7.875H8.43748Z"
                          fill="#8B9AB0"
                          fill-opacity="0.75"
                        />
                        <path
                          d="M13.3126 7.875C13.3126 7.15199 13.3114 6.66632 13.2627 6.30404C13.2162 5.95795 13.1357 5.80983 13.038 5.71209C12.9403 5.61435 12.7921 5.53393 12.446 5.4874C12.0838 5.4387 11.5981 5.4375 10.8751 5.4375H9.56256V7.875H13.3126Z"
                          fill="#8B9AB0"
                          fill-opacity="0.75"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.74994 3.00003H8.24994C5.42153 3.00003 4.00732 3.00003 3.12864 3.87871C2.36179 4.64556 2.26419 5.82032 2.25177 7.98708V9.19991C1.96651 9.36408 1.74144 9.61863 1.61412 9.92598C1.49994 10.2017 1.49994 10.5511 1.49994 11.25C1.49994 11.949 1.49994 12.2984 1.61412 12.5741C1.76636 12.9416 2.05837 13.2336 2.42591 13.3859C2.6152 13.4643 2.8393 13.4889 3.18744 13.4965V15C3.18744 15.3107 3.43928 15.5625 3.74994 15.5625C4.0606 15.5625 4.31244 15.3107 4.31244 15V13.5H13.6874V15C13.6874 15.3107 13.9393 15.5625 14.2499 15.5625C14.5606 15.5625 14.8124 15.3107 14.8124 15V13.4965C15.1606 13.4889 15.3847 13.4643 15.574 13.3859C15.9415 13.2336 16.2335 12.9416 16.3858 12.5741C16.4999 12.2984 16.4999 11.949 16.4999 11.25C16.4999 10.5511 16.4999 10.2017 16.3858 9.92598C16.2584 9.61863 16.0334 9.36408 15.7481 9.19998V7.98708C15.7358 5.82032 15.6381 4.64556 14.8713 3.87871C13.9926 3.00003 12.5784 3.00003 9.74994 3.00003ZM14.4374 9.0001V7.83603C14.4375 7.16219 14.4375 6.60024 14.3775 6.15417C14.3142 5.68333 14.1749 5.25823 13.8334 4.91663C13.4918 4.57502 13.0667 4.43577 12.5958 4.37246C12.1497 4.31249 11.5878 4.31251 10.9139 4.31253H7.08596C6.4121 4.31251 5.85019 4.31249 5.4041 4.37246C4.93326 4.43577 4.50815 4.57502 4.16656 4.91663C3.82495 5.25823 3.68569 5.68333 3.62239 6.15417C3.56242 6.60026 3.56244 7.16217 3.56246 7.83603V9.0001C3.62203 9.00003 3.68446 9.00003 3.74994 9.00003H14.2499C14.3154 9.00003 14.3779 9.00003 14.4374 9.0001Z"
                          fill="#8B9AB0"
                          fill-opacity="0.75"
                        />
                      </svg>
                      <div class="flex column">
                        <h4 class="characters__text">
                          {{ item.lot_bedroom }}
                        </h4>
                        <span class="gray-text"> спальни</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <!--  <div class="characters characters__wc flex">
                    <svg
                      class="characters__icon"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.75 7.49965H5.25V5.3344C5.25 4.58665 5.7585 3.89215 6.49575 3.77065C6.71109 3.73401 6.93184 3.74477 7.1426 3.80218C7.35336 3.8596 7.54906 3.96229 7.71607 4.10309C7.88308 4.24389 8.01737 4.41942 8.10958 4.61744C8.20179 4.81546 8.24971 5.03121 8.25 5.24965H9.75C9.74964 4.83063 9.66156 4.41632 9.49145 4.03338C9.32133 3.65044 9.07293 3.30735 8.76224 3.02619C8.45155 2.74503 8.08544 2.53202 7.68747 2.40086C7.2895 2.2697 6.86848 2.2233 6.4515 2.26465C4.89225 2.41615 3.75 3.8164 3.75 5.38315V7.49965H2.25C2.05109 7.49965 1.86032 7.57867 1.71967 7.71932C1.57902 7.85997 1.5 8.05074 1.5 8.24965V9.74965C1.5 11.7042 2.7555 13.3669 4.5 13.9872V16.4997H6V14.2497H12V16.4997H13.5V13.9872C15.2445 13.3669 16.5 11.7042 16.5 9.74965V8.24965C16.5 8.05074 16.421 7.85997 16.2803 7.71932C16.1397 7.57867 15.9489 7.49965 15.75 7.49965Z"
                        fill="#8B9AB0"
                        fill-opacity="0.75"
                      />
                    </svg>
      
                    <span class="gray-text characters__text">{{ item.wc }}</span>
                    <span class="gray-text"> санузла</span>
                  </div>-->
                    <div class="characters__area flex align-center mr-1 mb-4">
                      <svg
                        class="characters__icon"
                        width="50"
                        height="50"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.93762 2.25003C3.00564 2.25003 2.25012 3.00555 2.25012 3.93753V14.0625C2.25012 14.9945 3.00564 15.75 3.93762 15.75H14.0626C14.9946 15.75 15.7501 14.9945 15.7501 14.0625V3.93753C15.7501 3.00555 14.9946 2.25003 14.0626 2.25003H3.93762ZM4.50012 5.06253C4.50012 4.75187 4.75196 4.50003 5.06262 4.50003H6.93762C7.24828 4.50003 7.50012 4.75187 7.50012 5.06253C7.50012 5.37319 7.24828 5.62503 6.93762 5.62503H6.42062L7.71035 6.91478C7.93002 7.13445 7.93002 7.49061 7.71035 7.71026C7.4907 7.92993 7.13454 7.92993 6.91488 7.71026L5.62512 6.42053V6.93839C5.62512 7.24905 5.37328 7.50093 5.06262 7.50093C4.75196 7.50093 4.50012 7.24905 4.50012 6.93839V5.06253ZM13.3357 13.3361C13.2303 13.4416 13.0872 13.5009 12.938 13.5009H11.063C10.7523 13.5009 10.5005 13.249 10.5005 12.9384C10.5005 12.6277 10.7523 12.3759 11.063 12.3759H11.5801L10.2897 11.0853C10.0701 10.8656 10.0701 10.5094 10.2898 10.2897C10.5095 10.0701 10.8657 10.0701 11.0853 10.2898L12.3755 11.5802V11.0625C12.3755 10.7518 12.6273 10.5 12.938 10.5C13.2486 10.5 13.5005 10.7518 13.5005 11.0625V12.9384C13.5005 13.0875 13.4412 13.2306 13.3357 13.3361ZM13.5005 5.06299V6.93799C13.5005 7.24865 13.2486 7.50048 12.938 7.50048C12.6273 7.50048 12.3755 7.24865 12.3755 6.93799V6.42059L11.0852 7.71033C10.8654 7.93001 10.5093 7.92993 10.2897 7.71018C10.0701 7.49048 10.0701 7.13433 10.2899 6.9147L11.5796 5.62549H11.0621C10.7514 5.62549 10.4996 5.37365 10.4996 5.06299C10.4996 4.75233 10.7514 4.50049 11.0621 4.50049H12.938C13.0872 4.50049 13.2303 4.55975 13.3357 4.66524C13.4412 4.77073 13.5005 4.91381 13.5005 5.06299ZM4.66487 13.3356C4.55939 13.2302 4.50012 13.0871 4.50012 12.9379V11.0629C4.50012 10.7523 4.75196 10.5004 5.06262 10.5004C5.37328 10.5004 5.62512 10.7523 5.62512 11.0629V11.5797L6.91484 10.2898C7.1345 10.0701 7.49065 10.0701 7.71035 10.2897C7.93002 10.5094 7.93002 10.8656 7.71042 11.0853L6.42046 12.3754H6.93848C7.24915 12.3754 7.50102 12.6273 7.50102 12.9379C7.50102 13.2486 7.24914 13.5004 6.93848 13.5004H5.06262C4.91344 13.5004 4.77036 13.4412 4.66487 13.3356Z"
                          fill="#8B9AB0"
                          fill-opacity="0.75"
                        />
                      </svg>
                      <div class="flex column">
                        <h4 class="characters__text">
                          {{ item.lot_square }}
                          <span>м²</span>
                        </h4>
                        <span class="gray-text characters__text ma-0 pa-0">
                          площадь
                        </span>
                      </div>
                    </div>
                    <div
                      class="characters__otd flex align-center mr-1"
                      v-if="item.lot_otc"
                    >
                      <svg
                        class="characters__icon"
                        width="50"
                        height="50"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.125 14.625V13.5H3.375C2.9625 13.5 2.5875 13.335 2.3175 13.0575C2.04 12.7875 1.875 12.4125 1.875 12C1.875 11.2275 2.475 10.5825 3.2325 10.5075C3.2775 10.5 3.3225 10.5 3.375 10.5H14.625C14.6775 10.5 14.7225 10.5 14.7675 10.5075C15.1275 10.5375 15.4425 10.695 15.6825 10.9425C15.99 11.2425 16.155 11.67 16.1175 12.135C16.05 12.9225 15.3375 13.5 14.5425 13.5H10.875V14.625C10.875 15.66 10.035 16.5 9 16.5C7.965 16.5 7.125 15.66 7.125 14.625Z"
                          fill="#A8B3C4"
                        />
                        <path
                          d="M12.8929 1.5H9.93795C9.72795 1.5 9.56295 1.665 9.56295 1.875V3C9.56295 3.3075 9.30795 3.5625 9.00045 3.5625C8.93295 3.5625 8.87295 3.5475 8.81295 3.525C8.59545 3.45 8.43795 3.24 8.43795 3V1.875C8.43795 1.665 8.27295 1.5 8.06295 1.5H6.93043C6.72043 1.5 6.55543 1.665 6.55543 1.875V5.25C6.55543 5.5575 6.30043 5.8125 5.99293 5.8125C5.68543 5.8125 5.43043 5.5575 5.43043 5.25V3.5625V1.875C5.43043 1.6725 5.28043 1.515 5.07793 1.5H5.05543C3.75043 1.53 2.73793 2.6625 2.87293 3.975L3.15043 9.0375C3.17293 9.435 3.50293 9.75 3.90043 9.75H14.1004C14.4979 9.75 14.8279 9.435 14.8504 9.0375L15.1279 3.975C15.2629 2.6475 14.2204 1.5 12.8929 1.5Z"
                          fill="#A8B3C4"
                        />
                      </svg>
                      <div class="flex column">
                        <h4 class="characters__text">{{ item.lot_otc }}</h4>
                        <span class="gray-text characters__text">отделка</span>
                      </div>
                    </div>
                  </div>
                </div>
                <h3 class="mb-4">Описание</h3>
                <div class="discriptions mb-4">
                  {{ item.lot_description }}
                </div>
                <h3 class="mb-4">Дополнительно</h3>
                <div class="extra__block flex column mb-4">
                  <v-row class="comission">
                    <v-col class="comission__title gray-text" cols="6"
                      >Комиссия</v-col
                    >
                    <v-col class="comission__value" cols="6">{{
                      item.comission
                    }}</v-col>
                  </v-row>
                  <v-row class="comission">
                    <v-col class="comission__title gray-text" cols="6"
                      >Актуализировано</v-col
                    >
                    <v-col class="comission__value" cols="6">{{
                      item.lot_date_update
                    }}</v-col>
                  </v-row>
                  <v-row class="comission mb-4">
                    <v-col class="comission__title gray-text" cols="6"
                      >Тип сделки</v-col
                    >
                    <v-col class="comission__value" cols="6">{{
                      item.type
                    }}</v-col>
                  </v-row>
                  <h3 class="mb-4">Расположение</h3>

                  <yandex-map
                    :key="item.id"
                    cursor-grab
                    :settings="{
                      location: {
                        center: item.coordinates,
                        zoom: 15,
                      },
                    }"
                    height="55vh"
                  >
                    <yandex-map-default-scheme-layer />
                    <yandex-map-default-features-layer />
                    <yandex-map-controls :settings="{ position: 'top left' }">
                    </yandex-map-controls>
                    <yandex-map-controls
                      :settings="{
                        position: 'bottom left',
                        orientation: 'vertical',
                      }"
                    >
                    </yandex-map-controls>
                    <yandex-map-controls :settings="{ position: 'right' }">
                      <yandex-map-zoom-control />
                    </yandex-map-controls>
                    <YandexMapMarker
                      :marker-id="item.id"
                      :settings="{
                        position: 'top left-center',
                        coordinates: item.coordinates,
                        properties: { item },
                      }"
                    >
                      <div class="marker__container">
                        <div class="clip">
                          {{ item.jk_name }}
                        </div>
                        <div class="marker" />
                      </div>
                    </YandexMapMarker>
                  </yandex-map>

                  <!-- <v-row class="comission">
                    <v-col class="comission__title gray-text" cols="6">ID</v-col>
                    <v-col class="comission__value bold-text" cols="6">{{
                      item.id
                    }}</v-col>
                  </v-row>-->
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="position-sticky top-0" style="height: 20%">
          <v-sheet border class="pa-4" rounded="xl">
            <h1 class="mb-4">{{ item.currency + item.fullPrice }}</h1>
            <div class="flex justify-space-between">
              <p class="gray-text">Цена за метр</p>
              <p>{{ item.squarePrice }} за м²</p>
            </div>
            <div class="flex justify-space-between mb-4">
              <p class="gray-text">Тип жилья</p>
              <p>{{ item.status }}</p>
            </div>
            <div class="actions flex column">
              <v-btn
                class="presentation__btn text-none mb-1"
                height="100%"
                style="padding: 10px; font-size: 13px"
                rounded="xl"
                color="#FF8351"
                variant="flat"
                :disabled="loading"
                :loading="loading"
                @click="createPresentation('enable')"
                >{{ `Создать презентацию` }}</v-btn
              >
              <v-btn
                class="presentation__btn text-none"
                height="100%"
                style="padding: 10px; font-size: 12px"
                rounded="xl"
                color="#ECEFF1"
                variant="flat"
                :disabled="loading"
                :loading="loading"
                @click="addSelection"
                >{{ `Создать ссылку на объект` }}</v-btn
              >
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapZoomControl,
  YandexMapControls,
  YandexMapMarker,
} from "vue-yandex-maps";
import copy from "copy-to-clipboard";

export default {
  name: "Card-Wiev",
  props: {
    item: Object,
    modal: Boolean,
    select: Boolean,
  },
  components: {
    YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapZoomControl,
    YandexMapControls,
    YandexMapMarker,
  },
  emits: ["update:modal", "update:select"],
  data() {
    return {
      isUrlCopy: false,
      loading: false,
      direction: "",
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
    };
  },
  methods: {
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async addSelection() {
      let url = `https://client.lissearch.ru/?id=${this.item.id}`;

      const clickru = await axios.get("https://clck.ru/--", {
        params: { url },
      });
      const saveUrl = clickru.data;
      this.urlCopy = saveUrl;

      await this.pause(1);

      this.isUrlCopy = true;
      console.log({ saveUrl });
      copy(this.urlCopy);
      this.options = false;
    },
    async createPresentation(type) {
      try {
        this.items = [this.item];
        // console.log(this.items);
        this.loading = true;
        let formData = new FormData();
        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i];
          item.currencyArr = ["RUB", item.currency];
          for (const index in item) {
            formData.append(`cards[${i}][${index}]`, item[index]);
          }
          formData.append(`cards[${i}][presType]`, type);
        }

        const res = await axios.post(
          "https://lissearch.ru/backend/presentation/create_presentation.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const name = `${this.item.name}-${this.item.square} m2.pdf`;
        const link = document.createElement("a");
        link.href = res.data;
        link.download = name;
        this.loading = false;
        //window.open(link, "_blank");
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    swipe() {
      this.$emit("update:modal", false);
    },
    selected() {
      this.$emit("update:select", true);
    },
  },
};
</script>

<style>
.clip {
  z-index: 10 !important;
  cursor: pointer;
  bottom: 22px;
  right: -36px;
  padding: 2px;
  position: fixed !important;
  background-color: #ff8351;
  border-radius: 13px;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  text-align: center;
  min-width: 110px;
}

.clip::after {
  content: url("data:image/svg+xml;charset=UTF-8,%3csvg width='60' height='12' viewBox='0 0 60 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M59.3047 0H0.74414C1.58674 0.199128 2.46227 0.314337 3.36157 0.336229L17.7819 0.687281C23.6216 0.829443 28.6091 4.94152 29.8619 10.647C29.9967 11.2607 30.8624 11.2863 31.0331 10.6816L31.0768 10.5267C32.688 4.81974 37.8274 0.826804 43.7555 0.676281L56.6451 0.348997C57.5595 0.32578 58.4493 0.206156 59.3047 0Z' fill='%23FF8351'/%3e%3c/svg%3e ");
  position: fixed;
  bottom: 3px;
  right: 25px;
  display: grid;
  justify-items: center;
  width: 100%;
}

.clip span {
  color: white;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 23px;
  padding: 0 10px;
  width: 100%;
}
.cluster__marker {
  z-index: -1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  border: 2px white solid;
  width: 25px;
  height: 25px;
  color: #fff;
  background-color: #ff8351;
}
.marker {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  border: 2px white solid;
  width: 12px;
  height: 12px;
  background-color: #ff8351;
}

.marker span {
  font-size: 10px;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  width: 21px;
  height: 21px;
  display: grid;
  justify-items: center;
  align-items: center;
}
.close__card {
  z-index: 10;
  position: absolute;
  top: 20px;
  left: 20px;
}
.object__card {
  width: 100%;
  flex-direction: column;
  padding: 15px;
  background-color: #fff;
  border-radius: 35px;
  position: absolute;
  top: 43%;
}
.object__photo {
  position: relative;
}
.object__type {
  padding: 0 4px;
  border: 1px solid #ff8351;
  border-radius: 6px;
  background-color: #ff8351;
  color: #fff;
}
.object__status {
  padding: 0 4px;
  margin-right: 15px;
  border: 1px solid #f4f6f9;
  border-radius: 6px;
  background-color: #f4f6f9;
}
.object__price {
  margin-right: 15px;
  font-size: 26px;
  font-weight: 700;
}
.object__price__square {
  font-size: 16px;
}
.characters {
  justify-content: space-between;
  padding: 20px;
}
.comission {
  justify-content: space-between;
}
.actions__block {
  margin-bottom: 20px;
}
</style>
